import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "../../Styles/Firstcard.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { Printer, Edit, Trash2 } from 'lucide-react';
import ViewFeeStructure from "./ViewFeeStructure"; 
import ViewFeeStructure2 from "./ViewFeeStructure2";

export default function Firstcard() {
  const [feeCategories, setFeeCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedClass, setSelectedClass] = useState(null);
  const [viewMode, setViewMode] = useState(1); 
  const { yearID } = useParams();

  const viewBtnStyle = {
    fontSize: "13px",
    padding: "6px 12px",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    textDecoration: 'none' 
  };

  const iconStyle = { fontSize: "14px" };

  useEffect(() => {
    loadDataStudentFee();
  }, [yearID]);

  const loadDataStudentFee = async () => {
    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      academic: "cay25", 
    };

    try {
      const response = await simplePostCall(
        ApiConfig.feeStructurecatogorylist,
        JSON.stringify(requestBody),
      );

      if (response?.result && response?.data) {
        setFeeCategories(response.data);
      } else {
        setFeeCategories([]);
      }
    } catch (error) {
      setFeeCategories([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewClick = (item, index) => {
    setSelectedClass(item);
    
    if (index === 0) {
      setViewMode(1);
    } else if (index === 1) {
      setViewMode(2);
    } else if (index === 2) {
      setViewMode(3);
    } else {
      setViewMode(4);
    }
  };

  if (selectedClass) {
    return (
      <>
        {(() => {
          if (viewMode === 1) {
            return (
              <ViewFeeStructure 
                data={selectedClass} 
                yearID={yearID} 
                onBack={() => setSelectedClass(null)} 
              />
            );
          } else if (viewMode === 2) {
            return (
              <ViewFeeStructure2 
                data={selectedClass} 
                yearID={yearID} 
                onBack={() => setSelectedClass(null)} 
              />
            );
          } else if (viewMode === 3) {
            return (
              <ViewFeeStructure 
                data={selectedClass} 
                yearID={yearID} 
                onBack={() => setSelectedClass(null)} 
              />
            );
          } else {
            return (
              <ViewFeeStructure 
                data={selectedClass} 
                yearID={yearID} 
                onBack={() => setSelectedClass(null)} 
              />
            );
          }
        })()}
      </>
    );
  }

  return (
    <div className="firstcard-container my-4">
      <div className="special-header d-flex justify-content-between mb-4">
        <h4 className="page-title mt-2">Academic Year: {yearID}</h4>
        <Link to="/create-fee" className="btn custom-btn pt-2">Create</Link>
      </div>

      <div className="row fee-struc">
        {isLoading ? (
          <div className="col-12 text-center">
            <ScaleLoader color="#F4BB44" style={{ textAlign: "center", padding: "10px" }} />
            <p className="mt-2">Fetching classes for {yearID}...</p>
          </div>
        ) : feeCategories.length > 0 ? (
          feeCategories.map((item, index) => (
            <div className="col-md-12 col-lg-4 col-sm-12 mb-4" key={index}>
              <div className={`card ${index % 2 === 0 ? "kard1" : "kard2"} text-center`}>
                <div className="card-body">
                  <h5 className="card-title"><b>{item.class_name}</b></h5>
                  <p className="card-text">Total Fee: ₹{item.amount.toLocaleString()}</p>
                  
                  <button
                    className="btn"
                    style={viewBtnStyle}
                    onClick={() => handleViewClick(item, index)}
                  >
                    <i className="bi bi-arrow-up-right-square-fill" style={iconStyle}></i>
                    View
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 text-center">
            <p>No data found for the year {yearID}.</p>
          </div>
        )}
      </div>
    </div>
  );
}